/* eslint-disable no-inner-declarations */
<template>
  <div class="gridLayOut">
    <div class="grid">
      <div  v-for="(item,idx) in list" :key="idx" :id="item.placeId" :style="generate(item)" @click="goLocalView(item)"
      :class="{'grid__item grid__item--lg': idx%4 === 0 || idx%4 === 3, 'grid__item grid__item--sm': idx%4 === 1 || idx%4 === 2}">
        <div class="outer" v-if="!!item.sitePhotos">
          <div class="inner">
            <span>{{item.name}}</span>
          </div>
        </div>
        <div class="outerNoImg" v-else>
          <div class="innerNoImg">{{item.name}}</div>
          <div class="output">{{distance(item)}}</div>
          <div class="output">{{onfoot(item)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'PhotoGrid',
  data () {
    return {
      scrollY: 0,
      timer: null
    }
  },
  mounted () {
  },
  created: function () {
    // 핸들러 등록하기
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy: function () {
    // 핸들러 제거하기(컴포넌트 또는 SPA의 경우 절대 잊지 말아 주세요!)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    generate (item) {
      let hexValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e']
      function populate (a) {
        for (var i = 0; i < 6; i++) {
          let x = Math.round(Math.random() * 14)
          let y = hexValues[x]
          a += y
        }
        return a
      }
      if (!item.sitePhotos) {
        let newColor1 = populate('#')
        let newColor2 = populate('#')
        let angle = Math.round(Math.random() * 360)
        let gradient = 'linear-gradient(' + angle + 'deg, ' + newColor1 + ', ' + newColor2 + ')'
        // document.getElementById(item.placeId).style.background = gradient;
        return { 'background': gradient }
      } else {
        return { 'background-image': 'url(' + this.sitePhotos(item) + ')' }
      }
    },
    goLocalView (item) {
      this.$router.push({ name: 'localview', params: { lang: this.lang, type: item.siteType, placeId: item.placeId, currentPlace: item.placeId } })
    },
    sitePhotos (img) {
      if (img.sitePhotos) return `https://google-map-photos.s3.ap-northeast-2.amazonaws.com/${img.sitePhotos[0]}`
      else if (img.img) return img.img
    },
    handleScroll: function () {
      if (this.timer === null) {
        this.timer = setTimeout(function () {
          // this.addContent = window.scrollY
          clearTimeout(this.timer)
          this.timer = null
        }.bind(this), 100)
      }
    }
  },
  computed: {
    isActive () {
      return (item) => {
        return !!this.$route.params.currentPlaceId && (item.placeId === this.$route.params.currentPlaceId)
      }
    },
    // addContent: {
    //   get: function () {
    //     return this.scrollY
    //   },
    //   set: function (newValue) {
    //     let scrollTop = newValue
    //     let windowHeight = window.innerHeight;
    //     let documentHeight = document.documentElement.scrollHeight

    //     if(scrollY !==0){
    //       if( scrollTop + windowHeight + 50 > documentHeight ) {
    //         this.layout.push(...this.layout)
    //       }
    //     }
    //   }
    // },
    distance () {
      return (item) => {
        const distance = item.distance
        const d = distance >= 1000 ? (distance / 1000).toFixed(1) : distance
        const unit = distance >= 1000 ? 'km' : 'm'
        return `${this.locale.localinfo_fromhotel} ${regExp.comma(d)}${unit}`
      }
    },
    onfoot () {
      return (item) => {
        const secPerDistance = Math.floor(item.distance * 0.9) // sec per distance :: 1분에 66.6m -> 1m당 0.9초
        const LOCALE = this.locale
        function minSec (seconds) {
          const hour = parseInt(seconds / 3600)
          const min = parseInt((seconds % 3600) / 60)
          // const sec = seconds % 60
          let message = `${LOCALE.localinfo_onfoot} `
          if (seconds <= 60) {
            message += LOCALE.within1min
          } else {
            if (hour >= 1) {
              message += `${LOCALE.time_about} ${hour}${LOCALE.hour}`
            }
            if (min >= 1) {
              message += `${LOCALE.time_about} ${min}${LOCALE.minute}`
            }
            // if (sec >= 1) {
            //   message = message += ` ${sec}${LOCALE.seconds}`
            // }
          }
          return message
        }
        return minSec(secPerDistance)
      }
    }
  },
  props: [
    'lang',
    'locale',
    'list'
  ],
  components: {}
}
</script>

<style lang="scss" scoped>

  @media screen and (orientation: landscape) {
    @media (min-width: 468px) {
      .gridLayOut{
        // background-color: blue;
        // padding: 0px calc(50% - 340px) 0px calc(50% - 340px) !important;
        .grid {
          grid-gap: 10px;
        }
        .grid__item--lg {
          grid-column: span 14;
          grid-row: span 12;
          position: relative;
        }
        .grid__item--sm {
          grid-column: span 11;
          grid-row: span 12;
          position: relative;
        }
      }
      @media (min-width: 1440px) {
        .gridLayOut{
          // background-color: green;
          padding: 0px calc(50% - 520px) 0px calc(50% - 520px) !important;
          .grid {
            grid-gap: 20px;
          }
          .grid__item--lg {
            grid-column: span 8;
            grid-row: span 12;
            position: relative;
          }
          .grid__item--sm {
            grid-column: span 8;
            grid-row: span 12;
            position: relative;
          }
        }
      }
    }
  }
  .gridLayOut{
        padding: 0px calc(50% - 320px) 0px calc(50% - 320px);
  }
  .grid {
    display:grid;
    grid-template-columns: repeat(25,1fr);
    grid-gap: 2px;
  }

  .grid__item {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    object-fit: cover;
    overflow: visible;

    &:hover {
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    }
    &.active {
      box-shadow: 0 0 5px purple;
    }
  }

  .outer {
    position: absolute;
    right: 5px;
    bottom: 5px;
    left: 5px;
  }
  .inner{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    display: inline-block;
    max-width: 100%;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 700;
    line-height: 1.4rem;
    letter-spacing: -.4px;
    background-color: rgba(0,0,0,.6);
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: bottom;
  }
  .outerNoImg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90%;
    white-space: nowrap;
    color: #454845;
    font-weight: 700;
    font-family: 'Montserrat', 'Helvetica', sans-serif;
    font-size: 1.1rem;
  }
  .innerNoImg{
    padding: 0 5px;
    font-size: 1.2rem;
    letter-spacing: -.4px;
    background-color: rgba(220,220,235,0.5);
    border-radius: 7px;
    padding: 6px;
  }
  .output{
    color: #fff;
    text-align: center;
    font-family: "Fira-Mono", monospace;
    font-size: 0.8rem;
    font-weight: 300;
  }
  .outerNoImg:hover {
    background-color: rgba(220,220,235,0.7);
    transition: all ease 0.3s;
  }

  .grid .grid__item::before {
    content: "";
    padding-bottom: 100%;
    display: inline-block;
    vertical-align: top;
  }
  .grid__item--lg {
    grid-column: span 14;
    grid-row: span 12;
    position: relative;
  }
  .grid__item--sm {
    grid-column: span 11;
    grid-row: span 12;
    position: relative;
  }
</style>
